export interface ApplicationProgressInfo {
  ApplicationID: number;
  BrokerAppID: string;
  LoanAmount: number;
  CompanyName: string;
  StageName: string;
  Status: string | null;
}
